<template>
<div id='un_chooseproduct'>
  <div class='product_nav-header' v-if='selectedItem && products'>
    <h2>{{selectedItem.type_of.name}} Products <span>{{products.length}} Shown</span></h2>
    <input type="text" class='form-el' v-model='filterValue' placeholder='Filter by..'>
  </div>
  <div class='un_chooseproduct_wrap' v-if='!loading.state' >
    <ProductTile
      v-for='product in products'
      :key='product.id'
      :product='product'/>
  </div>
</div>
</template>
<script>
import { mapState, mapMutations, mapActions } from 'vuex'
import ProductTile from './ProductTile.vue'
export default {
  data () {
    return {
      filterValue: null,
      filteredSet: null,
      allItems: null,
      itemData: null
    }
  },
  computed: {
    ...mapState('system', ['products', 'loading', 'selectedItem', 'items'])
  },
  watch: {
    $route: function (value) {
      if (value) {
        if (value.name === 'product-listing') {
          this.getProductsByItem(value.params.itemId)
        }
      }
    },
    items: function (value) {
      if (value) {
        this.setSelectedItem(this.$route.params.itemId)
      }
    }
  },
  methods: {
    ...mapActions('system', ['getProductsByItem']),
    ...mapMutations('system', ['setSelectedItem'])
  },
  components: {
    ProductTile
  },
  mounted () {
    if (this.$route.name === 'product-listing') {
      this.getProductsByItem(this.$route.params.itemId)
    }
  }
}
</script>
<style lang='scss'>
#un_chooseproduct{
  position: absolute;
  top:0;
  height:100%;
  width: calc(100% - 31rem);
  left: 31rem;
  padding: 4rem;
  overflow-y: scroll;
  .product_nav-header{
    position: absolute;
    top: 0;
    left: 3rem;
    width: calc(100% - 6rem);
    padding: 3rem 0rem 1rem 0rem;
    margin-bottom: 3rem;
    border-bottom: 1px solid #d0d0e2;
    h2{
      color:#1e1e6b;
      display: inline-block;
      span{
        color: #aaaaca;
        @include font-size(1);
        @include type_book;
        margin-left:0.5rem;
      }
    }
    input{
      display: inline-block;
      float: right;
    }
  }
  .un_chooseproduct_wrap{
    margin-top: 7rem;
  }
}
</style>



// WEBPACK FOOTER //
// uncommon-client/components/gold-admin/ProductSelection.vue